module.exports = {"id":"198817","name":"Romain Amalfitano","rating":"73","photo":"./data/images/photos/4/198817.png","club":{"name":"Dijon FCO","logo":"./data/images/clubs/DijonFCO.png"},"positions":["MC","MDC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomainAmalfitano0.json
// module id = 3683
// module chunks = 0